"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ServerSideEncryptionByDefault_1 = require("./_ServerSideEncryptionByDefault");
exports._ServerSideEncryptionRule = {
    type: "structure",
    required: [],
    members: {
        ApplyServerSideEncryptionByDefault: {
            shape: _ServerSideEncryptionByDefault_1._ServerSideEncryptionByDefault
        }
    }
};
//# sourceMappingURL=_ServerSideEncryptionRule.js.map